import { jsonProperty, Serializable } from "ts-serializable";

class Questionnaire extends Serializable{

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    titulo: string | null = null;

    @jsonProperty(Number, null)
    versao: number | null = null;
    
    @jsonProperty([Object])
    enunciados: Object[] = [];

    @jsonProperty([Object])
    fluxo: Object[] = [];
}  

export default Questionnaire;